<div class="font-syne text-2xl font-semibold mb-10">Betingelser</div>

<div class="flex">
  <input
    [(ngModel)]="ksfAcceptConditions.acceptedTradingConditions"
    type="checkbox"
    class="shrink-0 border-gray-200 focus:border-[#1FAD96] focus:ring-2 focus:ring-teal-500/25 focus:outline-none checked:bg-[#34C0A7] text-[#34C0A7] rounded"
    id="acceptedTradingConditions"
  />
  <label for="acceptedTradingConditions">
    <p
      [ngClass]="{
        'text-red-500': this.errorInTradingConditionsCheckbox,
      }"
      class="ml-4 text-sm"
    >
      <span *ngIf="textDirectedToCustomer">Du</span>
      <span *ngIf="!textDirectedToCustomer">Kunden</span>
      accepterer
      <a href="assets/docs/Forsikringsbetingelser_ksf.pdf" target="_blank"
        >handelsbetingelserne</a
      >
      og databehandlererklæringen og erkender, at de ikke er registreret i RKI,
      samt at der ikke har været nogen skader de sidste 3 år og ikke er blevet
      opsagt af nuværende forsikringsselskab
      <span class="text-red-500">*</span>
    </p></label
  >
</div>

<div class="flex mt-4">
  <input
    [(ngModel)]="ksfAcceptConditions.acceptedInfoIsCorrect"
    type="checkbox"
    class="shrink-0 border-gray-200 focus:border-[#1FAD96] focus:ring-2 focus:ring-teal-500/25 focus:outline-none checked:bg-[#34C0A7] text-[#34C0A7] rounded"
    id="acceptedInfoIsCorrect"
  />
  <label for="acceptedInfoIsCorrect">
    <p
      [ngClass]="{
        'text-red-500': this.errorInInfoIsCorrecCheckbox,
      }"
      class="ml-4 text-sm"
    >
      <span *ngIf="textDirectedToCustomer">Du</span>
      <span *ngIf="!textDirectedToCustomer">Kunden</span> erklærer hermed på tro
      og love, at de indtastede informationer er korrekte og erkender, at det er
      strafbart, hvis informationerne er falske eller ukorrekte
      <span class="text-red-500">*</span>
    </p></label
  >
</div>

<div *ngIf="chargingStand">
  <div class="flex mt-4">
    <input
      [(ngModel)]="ksfAcceptConditions.acceptedChargingStandCustomer"
      type="checkbox"
      class="shrink-0 border-gray-200 focus:border-[#1FAD96] focus:ring-2 focus:ring-teal-500/25 focus:outline-none checked:bg-[#34C0A7] text-[#34C0A7] rounded"
      id="acceptedChargingStandCustomer"
    />
    <label for="acceptedChargingStandCustomer">
      <p
        [ngClass]="{
          'text-red-500': this.errorInChargingStandCustomer,
        }"
        class="ml-4 text-sm"
      >
        <span *ngIf="textDirectedToCustomer">Du</span>
        <span *ngIf="!textDirectedToCustomer">Kunden</span> samtykker til, at
        navn, adresse, telefonnummer og e-mail må videregives til Energi Fyn med
        henblik på at blive direkte kontaktet af Energi Fyn for tilbud på
        lade-abonnement mv.<span class="text-red-500">*</span>
      </p></label
    >
  </div>

  <div class="flex mt-4">
    <input
      [(ngModel)]="ksfAcceptConditions.acceptedChargingStandConsultant"
      type="checkbox"
      class="shrink-0 border-gray-200 focus:border-[#1FAD96] focus:ring-2 focus:ring-teal-500/25 focus:outline-none checked:bg-[#34C0A7] text-[#34C0A7] rounded"
      id="acceptedChargingStandConsultant"
    />
    <label for="acceptedChargingStandConsultant">
      <p
        [ngClass]="{
          'text-red-500': this.errorInChargingStandConsultant,
        }"
        class="ml-4 text-sm"
      >
        <span *ngIf="textDirectedToCustomer"
          >Du samtykke til at videregive dine oplysninger til Energi Fyn.<span
            class="text-red-500"
            >*</span
          ></span
        >
        <span *ngIf="!textDirectedToCustomer">
          Forhandleren bekræfter at have modtaget kundens samtykke til at
          videregive kundens oplysninger til Energi Fyn.<span
            class="text-red-500"
            >*</span
          ></span
        >
      </p></label
    >
  </div>
</div>

<div class="flex mt-4">
  <input
    [(ngModel)]="ksfAcceptConditions.acceptedAsgMarketing"
    type="checkbox"
    class="shrink-0 border-gray-200 focus:border-[#1FAD96] focus:ring-2 focus:ring-teal-500/25 focus:outline-none checked:bg-[#34C0A7] text-[#34C0A7] rounded"
    id="acceptedAsgMarketing"
  />
  <label for="acceptedAsgMarketing">
    <p class="ml-4 text-sm">
      <span *ngIf="textDirectedToCustomer">
        Ja tak, jeg vil gerne modtage nyhedsbrev fra Autosource Group-koncernen,
        hvor jeg får nyheder, tips og gode råd via mail. Samtidig giver jeg
        samtykke til, at de oplyste personoplysninger må opbevares og anvendes
        til dette formål. Du kan altid tilbagekalde sit samtykke direkte i
        nyhedsbrevet eller ved at skrive til marketing&#64;autosourcegroup.dk.
        Du kan læse mere om, hvordan vi behandler dine personlige data på
        <a
          class="underline"
          target="_blank"
          href="https://asgcare.dk/persondatapolitik"
          >dette link.</a
        ></span
      >
      <span *ngIf="!textDirectedToCustomer">
        Ja tak, kunden vil gerne modtage nyhedsbrev fra Autosource
        Group-koncernen, hvor kunden får nyheder, tips og gode råd via mail.
        Samtidig giver kunden samtykke til, at kundens oplyste personoplysninger
        må opbevares og anvendes til dette formål. Kunden kan altid tilbagekalde
        sit samtykke direkte i nyhedsbrevet eller ved at skrive til
        marketing&#64;autosourcegroup.dk. Kunden kan læse mere om, hvordan vi
        behandler dine personlige data på
        <a
          class="underline"
          target="_blank"
          href="https://asgcare.dk/persondatapolitik"
          >dette link.</a
        ></span
      >
    </p></label
  >
</div>

<div class="my-4">
  <span class="ml-8 text-sm"
    ><span class="text-red-500">*</span> = påkrævet</span
  >
</div>

<div class="mt-10">
  <button
    *ngIf="!applyForInsuranceLoading"
    (click)="applyForKSF()"
    class="py-3 px-4 shadow-lg font-syne inline-flex items-center gap-x-1 text-sm font-semibold rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
  >
    Anmod om tilbud
  </button>
  <div class="m-5" *ngIf="applyForInsuranceLoading">
    <lib-loading-indicator size="10"></lib-loading-indicator>
  </div>
</div>
